<style scoped lang="less">
.layout{position: absolute; background: rgba(2, 36 ,38,.5);-webkit-filter: drop-shadow(0 .0625rem .25rem rgba(0, 0, 0, 0.2)); filter: drop-shadow(0 .0625rem .25rem rgba(0, 0, 0, 0.2));overflow: hidden;border-radius: .625rem; bottom: .75rem;height: 25rem; top: 40%;left: 40%;transform: translate(-50%, -50%);}
.title{width: 41.25rem; height: 1.875rem;background: rgba(33, 185, 191, 0.6);margin: 0;line-height: 1.875rem;text-align: right;padding: 0 1.25rem;color: #fff; font-size: 1rem;display: flex;justify-content: space-between;}
.popup-content {width: 43.125rem;height: 22.5rem;;color: #d6d4d4; font-family: Microsoft YaH;text-align: left;padding: .3125rem;}
.ol-popup-closer:after {content: "✖";}
//设置整个table样式
/deep/.el-table{background: none !important;}
//修改表格头部样式
/deep/.el-table tr {background: none !important; }
/deep/.el-table tr .is-center{background: none !important; color: #fff; border: none;}
//修改分页菜单yangs
/deep/.el-pager li{background: transparent !important; color: #fff;}
/deep/.el-pager > .active{background: transparent !important; color: #23fffc;}
/deep/.btn-prev{background: transparent !important;color: #fff !important;}
/deep/.btn-next{background: transparent !important;color: #fff !important;}
/deep/.el-table__header th {padding: 0;height: 1.875rem;}
/deep/.el-table__body td {padding: 0;height: 1.875rem;}
.echarts {height: 2.5rem;line-height: 2.5rem;}
.echarts span{display: inline-block;height: 1.875rem;line-height: 1.875rem;;border: .0625rem solid rgba(33, 185, 191, 0.6);padding: 0rem .3125rem;}
.echarts span:hover {cursor: pointer;}
</style>

<template>
  <div class="layout" v-drag v-if="flag">
    <p class="title">
      <span>搜索结果</span>
      <a href="#" id="popup-closer" class="ol-popup-closer" @click="closePul(false)"></a>
    </p>
    <div class="popup-content">
      <div class="echarts">
        <span @click="drawbar('bar')"><i class="iconfont icon-zhuzhuangtu"></i>柱状图</span>
        <span @click="drawbar('pie')"><i class="iconfont icon-bingzhuangtu"></i>饼图</span>
        <span @click="drawbar('line')"><i class="iconfont icon-tubiao-zhexiantu"></i>折线图</span>
        <span @click="onClickExpExcel()"><i class="iconfont icon-daochu"></i>导出报表</span>
      </div>
      <el-table :header-cell-style="headercell" :row-style='rowstyles' :data="tableData" stripe height="360" style="width: 100%">
        <el-table-column align="center" prop="ssgj" label="国家"></el-table-column>
        <el-table-column align="center" prop="type" label="类型"></el-table-column>
        <el-table-column align="center" prop="num" label="总数量"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import SpaceQuery from './SpaceQuery'
import VectorSource from 'ol/source/Vector'
import VectorLayer from 'ol/layer/Vector'
import Style from 'ol/style/Style'
import Feature from 'ol/Feature'
import Point from 'ol/geom/Point'
import Icon from 'ol/style/Icon'
export default {
  mixins: [SpaceQuery],
  data()
  {
    return {
      measureAry: [],
      flag: false,
      tableData: [],
      temp: [],
      xAxisdata: [],
      seriesdata: [],
      LayernarData: [],
      searchtype: 'Poi'
    }
  },
  computed: {
    TableData()
    {
      return this.tableData
    },
    ...mapState({
      curID: state => state.searchtype
    })
  },
  watch: {
    curID:
    {
      handler(nval, oval)
      {
        this.searchtype = nval
      },
      immediate: true
    }
  },
  methods:
  {
    //关闭插件
    closePul(show)
    {
      this.flag = show
      this.$emit('closeEcharts')
    },
    search(val)
    {
      if (val)
      {
        if (this.searchtype === 'Poi')
        {
          if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
          {
            window.TianDiApi.getQyCoor(val).then(ret =>
            {
              window.map.getView().animate({ // 只设置需要的属性即可
                center: ret, // 中心点
                zoom: 8, // 缩放级别
                rotation: undefined, // 缩放完成view视图旋转弧度
                duration: 1000 // 缩放持续时间，默认不需要设置
              })
              let coordinate = ret
              let rome = new Feature({
                geometry: new Point(coordinate) //几何信息
              })
              var vector = new VectorSource()
              vector.addFeature(rome)
              var wfsVectorLayer = new VectorLayer({
                source: vector,
                style: new Style({
                  image: new Icon({
                    color: '#BADA55',
                    crossOrigin: 'anonymous',
                    src: '../../../../../static/index/map-marker (1).png'
                  })
                })
              })
              this.LayernarData.push(wfsVectorLayer)
              window.map.addLayer(wfsVectorLayer)
            })
          }
          else
          {
            let paras =
            {
              cmd: 'transGet',
              path: `http://api.tianditu.gov.cn/geocoder?tk=02da3c19240aed3f381b808153cdbafc&ds={"keyWord":"${val}"}`
            }
            window.post.getTDTSvr(paras).then((ret) =>
            {
              let evt = [ret.location.lat, ret.location.lon]
              window.map.getView().animate({ // 只设置需要的属性即可
                center: evt, // 中心点
                zoom: 8, // 缩放级别
                rotation: undefined, // 缩放完成view视图旋转弧度
                duration: 1000 // 缩放持续时间，默认不需要设置
              })
              let coordinate = evt
              let rome = new Feature({
                geometry: new Point(coordinate) //几何信息
              })
              var vector = new VectorSource()
              vector.addFeature(rome)
              var wfsVectorLayer = new VectorLayer({
                source: vector,
                style: new Style({
                  image: new Icon({
                    color: '#BADA55',
                    crossOrigin: 'anonymous',
                    src: '../../../../../static/index/map-marker (1).png'
                  })
                })
              })
              this.LayernarData.push(wfsVectorLayer)
              window.map.addLayer(wfsVectorLayer)
            })
          }
        }
        else if (this.searchtype === 'Kyq')
        {
          this.flag = true
          let exp = `ssgj = '${val}'`
          let paras = {cmd: 'query', _major: 11, _minor: 73, _exp: exp}
          window.post.getPost(paras).then((ret) =>
          {
            this.tableData = []
            let tempName = []
            let tempNum = []
            ret.forEach(item =>
            {
              if (tempName.indexOf(item.type) === -1)
                tempName.push(item.type)
            })
            this.xAxisdata = tempName
            tempName.forEach(item1 =>
            {
              let num = 0
              ret.forEach(item2 =>
              {
                if (item1 === item2.type)
                  num++
              })
              tempNum.push(num)
            })
            this.seriesdata = tempNum
            tempName.forEach((item, index) =>
            {
              this.tableData.push({
                ssgj: val,
                type: tempName[index],
                num: tempNum[index]
              })
            })
          })
        }
      }
      else
        this.$message({message: '请输入搜索内容', type: 'warning', customClass: 'mzindex'})
    },
    clear()
    {
      this.LayernarData.forEach(e =>
      {
        e.getSource().clear()
        window.map.removeLayer(e)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/kyyzt/Search.vue